import { InteractivityDataSourceService } from './../interactivity-editor/services/interactivity-data-source.service';
import { Component, Input, Output, EventEmitter, OnDestroy, OnInit, HostBinding } from '@angular/core';
import { Filter, FilterConfig, FilterSet, FilterSetService } from '../../../services/filter-set.service';
import dayjs from 'dayjs';

@Component({
	selector: 'bb-vertical-filter',
	templateUrl: './bb-vertical-filter.component.html',
	styleUrls: ['./bb-vertical-filter.component.scss']
})

export class BbVerticalFilterComponent implements OnInit, OnDestroy {
	@Input() filter: Filter;
	@Input() allowDatasource = false;
	@Input() useMatFields = false;

	@Output() onFilterChanged = new EventEmitter();

	@HostBinding('class.mat-fields-theme') get isMatFieldsTheme() {
		return this.useMatFields;
	}

	filterSet: FilterSet;

	fieldInterfaceType: string;
	filterConfigOptions: any[] = [];
	operatorType: string;
	today: Date = new Date();
	currentTime: string;
	inTheLastNumber: number;
	inTheLastPeriod: string;

	options: any[];
	calendarOpen = false;

	private filterConfig: FilterConfig[] = [];

	constructor(
		private filterSetService: FilterSetService,
		public dataSourceService: InteractivityDataSourceService
	) {
	}

	ngOnInit() {
		this.filterConfig = this.filterSetService.getFilterConfig();
		this.filterSet = this.filterSetService.getFilterSet();

		if (this.filter) {
			if (this.filter.field) {
				const filterConfigOption = this.filterSetService.getFilterConfigForProperty(this.filter.field);
				if (filterConfigOption) {
					this.fieldInterfaceType = filterConfigOption.type;
				}
				this.determineOperatorType();
				if (!this.filter.value) {
					this.setFilterDefaults();
				} else if (this.filter.operator === 'isInTheLast' || this.filter.operator === 'isNotInTheLast') {
					const valueString = this.filter.value.toString();
					const valueNumber = valueString.match(/[+-]?\d+(?:\.\d+)?/g).map(Number);
					this.inTheLastNumber = valueNumber[0];
					this.inTheLastPeriod = valueString.replace(/[+-]?\d+/g, '').toLowerCase();
				}
			}
		}

		this.addValueToOptions();
	}

	addValueToOptions() {
		if (!this.filterConfig) {
			this.filterConfig = [];
		}
		for (let i = 0; i < this.filterConfig.length; i++) {
			const filterConfigOption = {
				label: this.filterConfig[i].label,
				value: this.filterConfig[i].property
			};
			this.options = this.filterConfig[i].options;
			this.filterConfigOptions.push(filterConfigOption);
		}
	}

	ngOnDestroy() {
	}

	// obsolete function?
	getToday(): string {
		const today = dayjs().format();
		this.getCurrentTime();
		return today;
	}

	getCurrentTime() { // current time for initial display
		const today = new Date();
		const h = (today.getHours() < 10 ? '0' : '') + today.getHours();
		const m = (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
		this.currentTime = h + ':' + m;
	}

	filterFieldChanged(value: any) {
		const filterConfigOption = this.filterConfig.find(config => config && config.property === value);
		if (filterConfigOption) {
			this.fieldInterfaceType = filterConfigOption.type;
			this.filter.type = filterConfigOption.entity || 'mediaclip';
		}
		this.determineOperatorType();
		this.setFilterDefaults();
		this.filterChanged();
	}

	determineOperatorType() {
		switch (this.fieldInterfaceType) {
			case 'multiSelect':
			case 'multiClipSelect':
			case 'customMultiSelect':
				this.operatorType = 'containsAny';
				break;
			case 'select':
			case 'singleSelect':
			case 'singleClipSelect':
				this.operatorType = 'is';
				break;
			case 'date':
				this.operatorType = 'isDate';
				break;
			case 'number':
			case 'facetquery':
				this.operatorType = 'isNumber';
				break;
			case 'boolean':
				this.operatorType = 'boolean';
				break;
			case 'text':
			case 'textarea':
				this.operatorType = 'contains';
				break;
		}
	}

	setFilterDefaults() {
		// select default value for operator, depending on type
		switch (this.operatorType) {
			case 'boolean':
				this.filter.operator = 'is';
				this.filter.value = 'true';
				break;
			case 'containsAny':
				this.filter.operator = 'containsAnyOf';
				this.filter.value = null;
				break;
			case 'isEmpty':
				this.filter.operator = 'isEmpty';
				this.filter.value = '*'; // backend needs a value to work
				break;
			case 'isNotEmpty':
				this.filter.operator = 'isNotEmpty';
				this.filter.value = '*'; // backend needs a value to work
				break;
			case 'is':
			case 'isNumber':
				this.filter.operator = 'is';
				this.filter.value = null;
				break;
			case 'isDate':
				this.filter.operator = 'isBefore';
				this.filter.value = null;
				break;
			case 'contains':
				this.filter.operator = 'contains';
				this.filter.value = null;
				break;
		}
	}

	operatorChanged(value: any) {
		if (value === 'isEmpty' || value === 'isNotEmpty') {
			// backend needs a value to work
			this.filter.value = '*';
		} else if (this.filter.value === '*') {
			this.filter.value = '';
		} else if ((value === 'isInTheLast' || value === 'isNotInTheLast') && this.inTheLastPeriod) {
			this.filter.value = this.inTheLastNumber + this.inTheLastPeriod.toUpperCase();
		}

		this.filterChanged();
	}

	valueChanged(event: Event, inTheLast: boolean) {
		if (this.filter.value && (this.fieldInterfaceType === 'number' || this.fieldInterfaceType === 'facetquery')) {
			this.filter.value = this.filter.value.toString();
		}
		if (inTheLast) {
			if (this.inTheLastPeriod && this.inTheLastNumber) {
				this.filter.value = this.inTheLastNumber + this.inTheLastPeriod.toUpperCase();
				this.filterChanged();
			}
		} else {
			this.filterChanged();
		}
	}

	calendarValueChanged(date: string): void {
		this.filter.value = date;
		this.filterChanged();
		this.calendarOpen = false;
	}

	filterChanged() {
		this.onFilterChanged.emit(this.filter);
	}
}
